import { CustomerItemDto, SortDirectionDto } from '@/api/generated';
import { CustomTableStateModel } from '@/components/table/model/CustomTableState.model.ts';
import {
  CustomerSearchFormModel,
  initialCustomerSearchFormModel,
} from '@/views/customers/list/model/CustomersSearchForm.model.ts';

export type CustomersTableState = CustomTableStateModel<
  string,
  CustomerSearchFormModel,
  CustomerItemDto
>;

export const initialCustomersTableState: CustomersTableState = {
  data: {
    items: [],
    totalPages: 0,
    totalResults: 0,
  },
  page: 0,
  pageSize: 10,
  params: initialCustomerSearchFormModel,
  sortBy: '',
  sortOrder: SortDirectionDto.Asc,
};
